import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'

export default function OverFlowTooltip(props) {
   // Create Ref
   const textElementRef = useRef();
   const additionalCss = Utils.isEmptyObject(props.additionalCss) ? {} : props.additionalCss

   const compareSize = () => {
       const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
       setHover(compare);
   };

   // compare once and add resize listener on "componentDidMount"
   useEffect(() => {
       compareSize();
       window.addEventListener('resize', compareSize);
   }, []);

   // remove resize listener again on "componentWillUnmount"
   useEffect(() => () => {
       window.removeEventListener('resize', compareSize);
   }, []);

   // Define state and function to update the value
   const [hoverStatus, setHover] = useState(false);
   return (
       <Tooltip
           title={props.value}
           disableHoverListener={!hoverStatus}
           style={{ fontSize: '2em' }}
           placement='top-start'
       >
           <div
               ref={textElementRef}
               style={{
                   whiteSpace: 'nowrap',
                   overflow: 'hidden',
                   textOverflow: 'ellipsis',
                   ...additionalCss
               }}
               className={`knowledge-outline user-name ${props.className ? props.className : ''}`}
           >
               {props.value}
           </div>
       </Tooltip>
   );
}

OverFlowTooltip.defaultProps = {
    value: ''
}
